import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "button-warning" }
const _hoisted_2 = { class: "dst-warning" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "select-label scale-select" }
const _hoisted_5 = { class: "select-label psd-axis-select" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "button-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("p", _hoisted_2, " You're plotting bursts that cross a DST (daylight savings time) boundary. The plots below may not display as expected. ", 512), [
        [_vShow, _ctx.crossesBoundary]
      ])
    ]),
    _withDirectives(_createVNode(_component_loading_spinner, null, null, 512), [
      [_vShow, _ctx.isLoading && _ctx.selectedPages.length]
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "chart-container" }, [
      _createElementVNode("div", {
        id: "graph",
        class: "graph"
      })
    ], -1)),
    (_ctx.sensors)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          disabled: !_ctx.isLoading,
          class: "psd-controls controls"
        }, [
          _createElementVNode("label", _hoisted_4, [
            _cache[4] || (_cache[4] = _createTextVNode("Scale: ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "range",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.psdScale) = $event))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("option", {
                key: "log",
                value: "log"
              }, "Log", -1),
              _createElementVNode("option", {
                key: "loglinear",
                value: "loglinear"
              }, "Log-linear", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.psdScale]
            ])
          ]),
          _createElementVNode("label", _hoisted_5, [
            _cache[5] || (_cache[5] = _createTextVNode("Axis: ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "range",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.psdSelectedAxis) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.axes, (axis) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: axis,
                  value: axis
                }, _toDisplayString(axis), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.psdSelectedAxis]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-success btn-sm plot-button",
            title: "Plot graph",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.replotPSD && _ctx.replotPSD(...args)))
          }, [
            _withDirectives(_createVNode(_component_loading_spinner, { size: "16px" }, null, 512), [
              [_vShow, _ctx.isLoading]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("div", null, "Plot", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", null, "PSD", -1)),
              _createVNode(_component_vue_feather, {
                type: "bar-chart",
                size: "16px"
              })
            ], 512), [
              [_vShow, !_ctx.isLoading]
            ])
          ])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "chart-container" }, [
      _createElementVNode("div", {
        id: "PSD-graph",
        class: "PSD-graph"
      })
    ], -1))
  ]))
}